<template>
	<div id="Slider">
		<div id="SliderInner">
			
			<span class="SliderFill" :style="{ width: this.width }"></span>
			<span class="SliderTrack"></span>
			
			<!--
			<span class="SliderItemFilled"></span>
			<span class="SliderItemFilled"></span>
			<span class="SliderItemFilled"></span>
			<span class="SliderItemFilled"></span>
			<span class="SliderItemFilled"></span>
			<span class="SliderItemFilled"></span>
			<span class="SliderItemFilled"></span>
			<span class="SliderItemFilled"></span>
			
			<span class="SliderItemEmpty"></span>
			<span class="SliderItemEmpty"></span>
			<span class="SliderItemEmpty"></span>
			<span class="SliderItemEmpty"></span>
			<span class="SliderItemEmpty"></span>
			-->
		</div>
	</div>
</template>

<script>
	import { Component, Vue, Prop } from 'vue-property-decorator';
	import KeyListenerView from '../KeyListenerView';

	@Component({
		components: {
		},
	})
	export default class Slider extends KeyListenerView {
		@Prop(Number) min;
		@Prop(Number) max;
		@Prop(Number) step;
		@Prop(Number) initialValue;
		value = 0;
		
		beforeMount() {
    		this.value = Math.max(this.min, Math.min(this.max,this.initialValue));
		}

    	mounted() {
        	this.addKeyboardListener('LEFT', this.onKeyLeft, 'Decrease value')
        	this.addKeyboardListener('RIGHT', this.onKeyRight, 'Increase value')
        	super.mounted();
    	}
    	
    	destroyed() {
        	super.destroyed();
    	}
    	    
        onKeyLeft() {
            this.value = this.value - this.step;
            this.value = Math.max(this.value, this.min);
            this.$emit('onValue', {value: this.value});
        }
    	    
        onKeyRight() {
            this.value = this.value + this.step;
            this.value = Math.min(this.value, this.max);
            this.$emit('onValue', {value: this.value});
        }
		
		get width() {
			return (( this.value - this.min ) / ( this.max - this.min ) ) * 100 + '%';
		}
	}
</script>

<style lang="scss">
#Slider {
	border: 3px double black;
	padding: 3px;
	
	display: flex;
	flex-direction: row;
}
	#SliderInner {
		position: relative;
		width: 100%;
		height: 3vmin;		
	}
	
	.SliderFill,
	.SliderTrack {
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
	}
	.SliderFill {
		z-index: 2;
		width: 30%;
		background: black;
	}
	.SliderTrack {
		z-index: 1;
		right: 0;
		background: url(../../assets/img/bg.png);	
	}

	.SliderItemEmpty,
	.SliderItemFilled {
		width: 2vmin;
		height: 3vmin;
	}
	.SliderItemEmpty {
		background: url(../../assets/img/bg.png);
	}
	.SliderItemFilled {
		background: black;
	}
</style>